import { Component, OnInit, Input, Output, ViewChildren, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiService, FilterService } from '../../custom-material/Services/';
import { BuildingModel, UserModel, IncidentModel } from '../../main/Models/';



@Component({
  selector: 'incident-list',
  templateUrl: './t_list.component.html',
  styleUrls: ['./list.component.less']
})
export class ListComponent implements OnInit {

  @Input() incidents: Array<IncidentModel> = [];

  //usefull only on inclueded component (building sheet), not in incident page
  @Input() selectedBuildingsList: Array<number> = [];

  filterService: FilterService;

  @Output()
  openTriggered: EventEmitter<any> = new EventEmitter();


  constructor(private apiService: ApiService,
              private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit() {
    //only on inclueded component (building sheet), not in incident page
    if(this.selectedBuildingsList.length>0)
      this.loadAllIncidents(this.selectedBuildingsList);
  }


  loadAllIncidents(selectedBuildingsList)
  {
    return new Promise((resolve, reject)=>{
    let params =
        'filter[0][type]=in'
        +'&filter[0][field]=building'
        +'&order-by[0][type]=field'
                          +'&order-by[0][field]=dtfacts'
                          +'&order-by[0][direction]=desc'
    let b=0;
    selectedBuildingsList.forEach(buildingId => {
        params += '&filter[0][values]['+b+']='+buildingId;
        b++;
    });

    this.apiService.getFromServer('incident', params)
       .then(s => s.subscribe((response:any) => {
         this.incidents = [];
          for( let i in response._embedded.incident) {
            this.incidents[i] = new IncidentModel(response._embedded.incident[i]);
          }

          this.filterService = new FilterService(this.incidents);
          resolve(true);
       })); 

    });
  }

  openIncident($event)
  {
    this.openTriggered.emit($event);
  }

  openIncidentById(id)
  {
    let incident = this.incidents.filter((incident)=>incident.id==id)[0];
    this.openTriggered.emit(incident);
  }

}
